import { createStore } from "vuex";
import {registrationModule} from "@/store/RegistrationModule";
import {createConnectionModule} from "@/store/CreateConnectionModule";

export const store = createStore({
    modules: {
        register: registrationModule,
        createFile: createConnectionModule
    }
})